import { HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EXTERNAL_LINK_TARGET } from "shared/enums/common.enum";
import { Query } from "shared/types/query";

@Injectable({
    providedIn: 'root'
})

export class UtilsService {
    splitPathBySlash(path: string): string[] {
        return path.split('/');
    }

    getQueryParams(query: Query) {
        const params = new HttpParams();
        for (let key in query) params.set(key, query[key]);
        return params;
    }

    goToExternalLink(link: string, target: EXTERNAL_LINK_TARGET = EXTERNAL_LINK_TARGET.BLANK) {
        window.open(link, target);
    }

    getCssVar(name: string): string {
        return getComputedStyle(document.documentElement)
            .getPropertyValue(name)
            .trim();
    }

    isImageFile(file: File) {
        const types = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp', 'image/svg+xml']
        return types.includes(file.type);
    }

    isExcelFile(file: File) {
        const types = [
            '.xls',
            '.xlsx',
            'application/vnd.ms-excel',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        ]

        return types.includes(file.type);
    }

    isZipFile(file: File) {
        const types = [
            '.zip',
            'application/zip',
            'application/x-zip-compressed'
        ]

        return types.includes(file.type);
    }

    enumToCamelCase(value: string): string {
        return value
            .toLowerCase()
            .split('_')
            .map((word, index) =>
                index === 0
                    ? word
                    : word.charAt(0).toUpperCase() + word.slice(1)
            )
            .join('');
    }
    downloadBinaryFile(data: any, name: string) {
        const blob = new Blob([data]);
        const blobUrl = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = name;
        a.click();
    }

    getDeviceName(): string {
        return `${this.getBrowserName()} on ${this.getOS()}`;
    }

    getDeviceInfo() {
        return {
            platform: 'web',
            browser: this.getBrowserName(),
            browserVersion: this.getBrowserVersion(),
            os: this.getOS(),
            userAgent: navigator.userAgent,
            language: navigator.language,
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            screen: `${window.screen.width}x${window.screen.height}`
        };
    }

    private getBrowserName(): string {
        const ua = navigator.userAgent;

        if (ua.includes('Edg')) return 'Edge';
        if (ua.includes('Chrome')) return 'Chrome';
        if (ua.includes('Firefox')) return 'Firefox';
        if (ua.includes('Safari')) return 'Safari';

        return 'Unknown Browser';
    }

    private getBrowserVersion(): string {
        const match = navigator.userAgent.match(
            /(Edg|Chrome|Firefox|Safari)\/(\d+)/
        );
        return match ? match[2] : 'Unknown';
    }

    private getOS(): string {
        const ua = navigator.userAgent;

        if (/windows/i.test(ua)) return 'Windows';
        if (/macintosh/i.test(ua)) return 'macOS';
        if (/android/i.test(ua)) return 'Android';
        if (/iphone|ipad/i.test(ua)) return 'iOS';
        if (/linux/i.test(ua)) return 'Linux';

        return 'Unknown OS';
    }
}